import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const IdvSliderContainer = styled.div`
  border-radius: 12px;
  background: #fff;
  padding: 1.5rem 1rem 0.5rem 1rem;
  width: 100%;
  ${(props) =>
    props.isIdvUpdated &&
    "border-bottom: 1px solid #e7e7f0; margin-bottom: 4px;"}
`;

export const Content = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #5b5675;
  ${(props) => props.styles}
  @media (min-width: 768px) {
    text-align: center;
  }
`;

export const Title = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  color: #040222;
`;

export const IdvPremiumContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ebfbee;
  border-radius: 12px;
  border: 1px solid #e7e7f0;
  margin-bottom: 32px;
  @media (max-width: 768px) {
    margin-top: -8px;
  }
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
  width: 100%;
`;

export const PremiumReductionBannerWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 1rem;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 0 0 12px 12px;
  background: #fff;
`;

export const PremiumWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(props) => props.styles}
`;

export const PremiumText = styled(Text)`
  color: #5b5675;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  ${(props) => props.styles}
`;

export const PremiumAmount = styled(Text)`
  color: #36354c;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  ${(props) => props.styles}
`;

export const PremiumReducedText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 8px 12px ;
  box-sizing: border-box;
  gap: 8px;
`;

export const IconContainer = styled.div`
  min-height: 20px;
  min-width: 20px;
`;

export const ReductionText = styled(Text)`
  color:  #0b753e;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px; 
`;